<template>
  <div v-if="isOpen" class="web3-modal fixed inset-0 z-50 flex items-center justify-center">
    <div class="modal-backdrop absolute inset-0 bg-black bg-opacity-50" @click="closeModal"></div>
    
    <div class="modal-content bg-gray-800 rounded-lg p-6 max-w-md w-full mx-4 relative z-10">
      <div class="flex justify-between items-center mb-4">
        <h2 class="text-xl font-semibold text-white">Connect Wallet</h2>
        <button @click="closeModal" class="text-gray-400 hover:text-white">
          ✕
        </button>
      </div>
      
      <div class="space-y-3">
        <button
          @click="connectWallet('metamask')"
          class="wallet-option w-full p-3 bg-gray-700 hover:bg-gray-600 rounded-lg flex items-center space-x-3 text-white transition-colors"
        >
          <div class="w-8 h-8 bg-orange-500 rounded-full flex items-center justify-center">
            🦊
          </div>
          <span>MetaMask</span>
        </button>
        
        <button
          @click="connectWallet('walletconnect')"
          class="wallet-option w-full p-3 bg-gray-700 hover:bg-gray-600 rounded-lg flex items-center space-x-3 text-white transition-colors"
        >
          <div class="w-8 h-8 bg-blue-500 rounded-full flex items-center justify-center">
            🔗
          </div>
          <span>WalletConnect</span>
        </button>
        
        <button
          @click="connectWallet('coinbase')"
          class="wallet-option w-full p-3 bg-gray-700 hover:bg-gray-600 rounded-lg flex items-center space-x-3 text-white transition-colors"
        >
          <div class="w-8 h-8 bg-blue-600 rounded-full flex items-center justify-center">
            💰
          </div>
          <span>Coinbase Wallet</span>
        </button>
      </div>
      
      <div class="mt-4 text-sm text-gray-400 text-center">
        Connect your wallet to access CuttleFusion features
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import { useWeb3Store } from '@/stores/web3'

const props = defineProps<{
  isOpen: boolean
}>()

const emit = defineEmits<{
  close: []
}>()

const web3Store = useWeb3Store()

const closeModal = () => {
  emit('close')
}

const connectWallet = async (type: string) => {
  try {
    await web3Store.connectWallet(type)
    closeModal()
  } catch (error) {
    console.error('Failed to connect wallet:', error)
  }
}
</script>

<style scoped>
.web3-modal {
  backdrop-filter: blur(4px);
}

.wallet-option:hover {
  transform: translateY(-1px);
}
</style>